// src/components/ReorganizingModal.jsx
import React from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import styles from '../ganttDx.module.css'
import LoadingScreen from '../LoadingScreen';


const ReorganizingModal = ({ show, onHide,reorganizing,message,title }) => (
  <Modal
    show={show}
    onHide={reorganizing ? onHide : ""}
    backdrop="static"
    keyboard={false}
    centered
    dialogClassName = {`${styles['reorg-modal-dialog']}`}
    size='sm'
  >
    <LoadingScreen 
    title={title}
    message={message}
    />
  </Modal>
);

ReorganizingModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
};

export default ReorganizingModal;
